import { h } from 'preact';

const TextInput = ({
  currentText,
  textMaxLength,
  textMinLength,
  changeHandler,
  showError,
  spacingBottom = true,
}) => (
  <div className={`${spacingBottom ? 'pb-5 mb-5' : ''}`}>
    <div className="body-3 mb-2.5">Text</div>
    <div className="body-3 border border-1 border-black px-3 py-2.5 h-[42px] flex gap-x-2 items-center justify-between">
      <input
        type="text"
        className="h-auto w-auto p-0 m-0 flex-1 border-0 focus:outline-none focus:ring-0"
        value={currentText}
        maxLength={textMaxLength}
        minLength={textMinLength}
        onChange={(e) => changeHandler({ value: e.target.value })}
      />
      <span>
        {currentText.length}/{textMaxLength}
      </span>
    </div>
    {showError && currentText.length > textMaxLength && (
      <p className="text-sale body-3 mt-1.5">
        {window.TMW.Strings.product.maxLengthMono.replace(
          '{textMaxLength}',
          textMaxLength,
        )}
      </p>
    )}
  </div>
);

export default TextInput;
